(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-banner"] && !Shopify.designMode) return;
  try {
    
  class BannerCollageSlider extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.slides = Array.from(this.querySelectorAll('.bc-slide'));
      this.dots = Array.from(this.querySelectorAll('.bc-dot'));
      this.index = Math.max(0, this.slides.findIndex((slide) => slide.classList.contains('is-active')));
      this.stop();
      this.interval = parseInt(this.getAttribute('data-autoplay'), 10) || 5000;
      if (this.slides.length <= 1) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.autoplayEnabled = this.dataset.autoplayEnabled !== 'false';
      this.pauseButton = this.querySelector('[data-banner-pause]');
      this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.sync();
      this.dots.forEach((dot) => {
        dot.addEventListener('click', (event) => {
          event.preventDefault();
          this.navigate(parseInt(dot.getAttribute('data-index'), 10));
        }, options);
      });
      this.querySelector('[data-banner-previous]')?.addEventListener('click', () => this.navigate(this.index - 1), options);
      this.querySelector('[data-banner-next]')?.addEventListener('click', () => this.navigate(this.index + 1), options);
      this.pauseButton?.addEventListener('click', () => {
        this.userPaused = !this.userPaused;
        this.sync();
        this.restart();
      }, options);
      this.addEventListener('mouseenter', () => this.stop(), options);
      this.addEventListener('mouseleave', () => this.start(), options);
      this.addEventListener('focusin', () => this.stop(), options);
      this.addEventListener('focusout', (event) => {
        if (!this.contains(event.relatedTarget)) setTimeout(() => this.start(), 0);
      }, options);
      this.onAutoplayChange = () => { this.sync(); this.restart(); };
      this.motionQuery.addEventListener('change', this.onAutoplayChange, options);
      document.addEventListener('visibilitychange', this.onAutoplayChange, options);
      this.addEventListener('keydown', (event) => {
        let next = this.index;
        if (event.key === 'ArrowRight') next++;
        else if (event.key === 'ArrowLeft') next--;
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = this.slides.length - 1;
        else return;
        event.preventDefault();
        this.navigate(next);
      }, options);
      const track = this.querySelector('.bc-slides');
      track?.addEventListener('pointerdown', (event) => {
        if (!event.isPrimary || event.button !== 0) return;
        this.gesture = { id: event.pointerId, x: event.clientX, y: event.clientY };
        this.stop();
      }, options);
      window.addEventListener('pointerup', (event) => {
        if (!this.gesture || event.pointerId !== this.gesture.id) return;
        const dx = event.clientX - this.gesture.x;
        const dy = event.clientY - this.gesture.y;
        this.gesture = null;
        if (Math.abs(dx) >= 40 && Math.abs(dx) > Math.abs(dy) * 1.25) {
          this.suppressClickUntil = Date.now() + 500;
          this.navigate(this.index + (dx < 0 ? 1 : -1));
        } else this.restart();
      }, options);
      window.addEventListener('pointercancel', () => { this.gesture = null; this.restart(); }, options);
      track?.addEventListener('dragstart', (event) => event.preventDefault(), options);
      this.addEventListener('click', (event) => {
        if (Date.now() < (this.suppressClickUntil || 0) && event.target.closest('.bc-slide')) {
          event.preventDefault();
          event.stopPropagation();
        }
      }, { ...options, capture: true });
      document.addEventListener('shopify:block:select', (event) => {
        const slide = event.target.closest('.bc-slide');
        const index = this.slides.indexOf(slide);
        if (index < 0) return;
        this.editorSelected = true;
        this.goTo(index);
        this.stop();
      }, options);
      document.addEventListener('shopify:block:deselect', (event) => {
        if (!this.contains(event.target)) return;
        this.editorSelected = false;
        this.restart();
      }, options);
      this.start();
    }

    disconnectedCallback() {
      this.stop();
      this.controller?.abort();
      this.gesture = null;
    }

    goTo(next) {
      if (!Number.isFinite(next) || !this.slides.length) return;
      const focusedSlide = this.slides[this.index].contains(document.activeElement);
      this.index = (next + this.slides.length) % this.slides.length;
      if (focusedSlide && !this.slides[this.index].contains(document.activeElement)) this.focus({ preventScroll: true });
      this.sync();
    }

    sync() {
      this.slides.forEach((slide, index) => {
        const active = index === this.index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', String(!active));
        slide.toggleAttribute('inert', !active);
      });
      this.dots.forEach((dot, index) => dot.classList.toggle('is-active', index === this.index));
      this.dots.forEach((dot, index) => dot.setAttribute('aria-current', String(index === this.index)));
      if (this.pauseButton) {
        this.pauseButton.disabled = !!this.motionQuery?.matches;
        this.pauseButton.setAttribute('aria-pressed', String(!!this.userPaused));
        this.pauseButton.setAttribute('aria-label', this.motionQuery?.matches ? 'Auto-rotation disabled for reduced motion' : this.userPaused ? 'Resume slideshow' : 'Pause slideshow');
        this.pauseButton.querySelector('[data-banner-play-icon]')?.toggleAttribute('hidden', !this.userPaused);
        this.pauseButton.querySelector('[data-banner-pause-icon]')?.toggleAttribute('hidden', !!this.userPaused);
      }
    }

    navigate(next) {
      this.goTo(next);
      const status = this.querySelector('[data-banner-status]');
      if (status) status.textContent = `Slide ${this.index + 1} of ${this.slides.length}`;
      this.restart();
    }

    next() {
      this.goTo(this.index + 1);
    }

    start() {
      const hovered = window.matchMedia('(hover: hover)').matches && this.matches(':hover');
      if (!this.isConnected || !this.autoplayEnabled || this.userPaused || this.editorSelected || this.gesture || this.slides.length <= 1 || this.timer || document.hidden || this.motionQuery?.matches || this.matches(':focus-within') || hovered) return;
      this.timer = setInterval(() => this.next(), this.interval);
    }

    stop() {
      if (this.timer) {
        clearInterval(this.timer);
      }
      this.timer = null;
    }

    restart() {
      this.stop();
      this.start();
    }
  }

  if (!customElements.get('banner-collage-slider')) customElements.define('banner-collage-slider', BannerCollageSlider);

  } catch(e) { console.error(e); }
})();
})();
